module.exports = __webpack_public_path__ + "morse.mp3?d06ae3ca0a2b0e1b0d4ebeda4165beda";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/morse.mp3
// module id = 478
// module chunks = 0